<div class="d-flex mb-3">
  <div class="me-auto d-flex">
    <div class="p-2 d-flex align-items-center cursor-pointer" (click)="backClicked()">
      <!-- <button (click)="backClicked()" class="btn btn-soft-primary"> -->
      <!-- <span class="mdi mdi-chevron-left" *ngIf="_language.getCurrentLang() === 'en'"></span>
        <span class="mdi mdi-chevron-right" *ngIf="_language.getCurrentLang() === 'he'"></span> -->
      <i-feather
        name="arrow-left-circle"
        *ngIf="_language.getCurrentLang() === 'en'"
        class="d-flex icon-lg"
      ></i-feather>
      <i-feather
        name="arrow-right-circle"
        *ngIf="_language.getCurrentLang() === 'he'"
        class="d-flex icon-lg"
      ></i-feather>
      <!-- </button> -->
    </div>
    <div class="p-2 d-flex align-items-center">
      <h5 class="mb-0" [class]="_router.url.includes('edit') || _router.url.includes('add') ? 'breadcrumb-title' : ''">
        {{ breadCrumbHeader.title | translate }}
      </h5>
    </div>
  </div>
  <ng-container *ngFor="let item of breadCrumbHeader?.breadCrumb">
    <div class="d-flex align-items-center">
      <li class="py-2 breadcrumb-item" *ngIf="item?.routeUrl; else currentBreadCrumb">
        <a [routerLink]="item?.routeUrl" [ngClass]="{ active: item.isActive, 'no-pointer-cursor': !item.isActive }">{{
          item.name | translate
        }}</a>
        <span class="mx-2 breadcrumb-separator">></span>
      </li>
      <ng-template #currentBreadCrumb>
        <li class="py-1 breadcrumb-item currentBreadCrumb badge bg-warning text-dark">
          {{ item.name | translate }}
        </li>
      </ng-template>
    </div>
  </ng-container>
</div>
